var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h2',{staticClass:"text_center more-top-padding black"},[_vm._v(_vm._s(this.$props.pageTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }